<ethervox-loader></ethervox-loader>
<div class="container">
  <ethervox-multicircuit></ethervox-multicircuit>
  <div class="context">
    <ethervox-channels></ethervox-channels>
    <ethervox-multicircuit-context-page></ethervox-multicircuit-context-page>
  </div>
</div>
